module.exports = __webpack_public_path__ + "static/media/8.44266b90.jpg";